import { createGetCollectionProductsAvailabilityApiHandler } from './helpers';

export const getPrivateCollectionsProductsAvailability = createGetCollectionProductsAvailabilityApiHandler('users');
